<template>
  <div>
    <!-- <div class="cp-product-view-bread-crumbs-container">
      <Breadcrumbs />
    </div> -->
    <router-view name="product-view" />
  </div>
</template>

<script>
// import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';

export default {
  name: 'ProductView',
  components: {
    // Breadcrumbs,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.cp-product-view {
  &-bread-crumbs-container {
    border-top: 1px solid $primary;
    border-bottom: 1px solid $primary;
  }
}
</style>
